import { API, authClient } from "../index";

export const postOfferChapter = async (offerChapter, accessToken) => {
  return authClient(accessToken).post(`${API}/offer-chapters`, offerChapter);
};

export const postOfferChapterNewRevision = async (
  id,
  capitulo,
  accessToken
) => {
  return authClient(accessToken).post(`${API}/offer-chapters/${id}`, capitulo);
};

export const getOfferChapters = (accessToken) => {
  return authClient(accessToken).get(`${API}/offer-chapters`);
};

export const getOfferChapterByIdAndRevision = (
  id,
  revisionNumber,
  accessToken
) => {
  return authClient(accessToken).get(
    `${API}/offer-chapters/${id}?revision=${revisionNumber}`
  );
};

export const getOfferChaptersById = (id, accessToken) => {
  return authClient(accessToken).get(`${API}/offer-chapters/${id}/all`);
};

export const updateOfferChapter = async (id, offerChapter, accessToken) => {
  return authClient(accessToken).put(
    `${API}/offer-chapters/${id}`,
    offerChapter
  );
};

export const deleteOfferChapter = (capituloId, accessToken) => {
  return authClient(accessToken).delete(`${API}/offer-chapters/${capituloId}`);
};
